import { useQuery } from "@tanstack/react-query";

import { getSubscriptionStatus, SubscriptionStatus } from "@/client/services/subscription";

export const useSubscription = () => {
  const { data, isLoading, error } = useQuery<SubscriptionStatus>({
    queryKey: ["subscription_status"],
    queryFn: () => getSubscriptionStatus(),
    refetchOnMount: "always",
  });

  return { subscription: data, loading: isLoading, error };
};
